/**
 * Check if the value is a valid EU VAT format
 * Reference: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s21.html
 * since 29-09-2023 (somewhere ish around this date) belgium VAT can also start with 1:
 * https://lkqeurope.atlassian.net/browse/CARCAT-231
 */
export const isValidBelgiumVAT = (value?: string): string | void =>
  value && !new RegExp(['^(BE)?[0-1][0-9]{9}$'].join('')).test(value) ? 'global.InvalidVATMessage_Belgium' : undefined
